import React, { forwardRef } from 'react';
import { StyledHeadline } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
import { pickDataAueProps } from '../../utils/pick-data-aue-props.js';
export const Headline = forwardRef(({ tag, children, variant, className, 'data-testid': dataTestId, margin, id, ...dataAueProps }, ref) => {
    return (React.createElement(StyledHeadline, { as: tag, id: id, className: className, variant: variant, "data-testid": dataTestId, ref: ref, margin: margin, ...pickDataAueProps(dataAueProps) }, children));
});
Headline.displayName = 'Headline';
//# sourceMappingURL=index.js.map